import VerticalStepper from './VerticalStepper'

export default VerticalStepper
